import axios from "@/axios"

const RESOURCE_NAME = '/ecosystem/settings';

export default {
    setGreetingShown: () => axios.post(`${RESOURCE_NAME}/set-greeting-shown`),
    getGreeting: () => axios.get(`${RESOURCE_NAME}/get-greeting`),
    saveGreeting: data => axios.post(`${RESOURCE_NAME}/save-greeting`, data),
}
